import { getTermsValue, setTerms } from './helpers';
import { TJsonQuery } from './types';
import { EBuildingTypeLegacy, EOfficeType } from '../api-models/common/json_query';

export function setBuildingType(jsonQuery: TJsonQuery) {
  return (values: EBuildingTypeLegacy[] | null): TJsonQuery => {
    const officeTypes = getTermsValue('office_type')(jsonQuery);
    const isOnlyBuilding = officeTypes?.length === 1 && officeTypes[0] === EOfficeType.Building;

    return isOnlyBuilding
      ? setTerms('building_type__building')(jsonQuery)(values)
      : setTerms('building_type2')(jsonQuery)(values);
  };
}
